import { useQuery } from "@apollo/client";

import { ProjectReviewVisitV2TimeReportsRoute_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2TimeReportsRoute_GetData(visitId: string) {
    const { data, loading, error, previousData } = useQuery(ProjectReviewVisitV2TimeReportsRoute_GetDataDocument, {
        variables: { visitId },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    const result = loading ? previousData : data;
    const visit = result?.plannerV2VisitGetById;

    const isOverridden =
        visit?.timeProtocolAutoValidationOverriddenAt != null &&
        visit?.timeProtocolAutoValidationOverriddenReason != null;

    return {
        visit,
        hasAllTimeRangesValid: result?.plannerVisitHasAllTimeRangesValid,
        isOverridden,
        loading,
        error,
    };
}
